module.exports = __webpack_public_path__ + "img/pinAjillo.777e81ad.jpg";